export default class ClearAnswerSearchResult {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.snippetSearchResult.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/clear_answer_search_result.js